<template>
<div class="container">
    <section class="top">
        <div class="avator">
            <img src="@/assets/avator.jpg" alt="头像" />
        </div>
        <h1>陈旭钦</h1>
        <h2>Web前端开发工程师</h2>
    </section>
    <section class="info">
        <div>男 / 1997.02</div>
        <div>广东工业大学 本科</div>
        <div>居住地: 广州市</div>
        <div>当前状态: 2020年应届生求职</div>
    </section>
    <section class="myUrl">
        <ul>
            <li v-for="(item, index) in myUrl" :key="index">
                <a :href="item.url" target="_blank">
                    <i class="iconfont" v-html="item.iconfont"></i>
                    <span>{{ item.content }}</span>
                </a>
            </li>
        </ul>
    </section>
    <section class="wrap">
        <div class="skill-level" v-for="(item, index) in levels" :key="index">
            <div>{{ item }}</div>
            <div class="out"><div :class="('in' + index)"></div></div>
        </div>
    </section>
</div>
</template>

<script>
export default {
    name: 'ContentRight',
    data() {
        return {
            levels: [
                'HTML', 'CSS', 'JavaScript', 'Vue', 'Webpack'
            ],
            myUrl: [
                {
                    url: 'https://github.com/brenner8023',
                    iconfont: '&#xe64a;',
                    content: 'github.com/brenner8023'
                },
                {
                    url: 'mailto:vue666@qq.com',
                    iconfont: '&#xe60d;',
                    content: 'vue666@qq.com'
                },
                {
                    url: 'javascript:;',
                    iconfont: '&#xe60e;',
                    content: '170-1727-1947'
                },
                {
                    url: 'https://brenner8023.github.io/fe-demo/vue-resume/index.html',
                    iconfont: '&#xe615;',
                    content: '网页版简历: http://1t.click/rG8'
                }
            ]
        }
    }
}
</script>

<style scoped>
@keyframes skillLevel0 {
    0% {
        width: 0%;
    }
    100% {
        width: 82%;
    }
}
@keyframes skillLevel1 {
    0% {
        width: 0%;
    }
    100% {
        width: 80%;
    }
}
@keyframes skillLevel2 {
    0% {
        width: 0%;
    }
    100% {
        width: 70%;
    }
}
@keyframes skillLevel3 {
    0% {
        width: 0%;
    }
    100% {
        width: 64%;
    }
}
@keyframes skillLevel4 {
    0% {
        width: 0%;
    }
    100% {
        width: 60%;
    }
}

.container {
    flex: 3.5;
    background: #eee;
    padding: 20px 30px 50px;
    box-sizing: border-box;
    text-align: left;
    font-size: 18px;
}
@media screen and (max-width: 1024px) {
.container {
    flex-grow: 1;
    flex-basis: 100%;
    order: 1;
    text-align: center;
}
}

.top {
    width: 100%;
    font-size: 48px;
    padding-top: 40px;
    color: #00b38a;
    text-align: center;
}
.avator img {
    display: block;
    width: 150px;
    margin: 0 auto;
    border-radius: 50%;
}
.top h1 {
    margin-top: 10px;
    letter-spacing: 10px;
}
.top h2 {
    font-size: 24px;
}

.info {
    color: #555;
    line-height: 32px;
    margin-top: 108px;
}

.wrap {
    width: 90%;
    margin-top: 108px;
}
.wrap .skill-level {
    margin-top: 24px;
}
.skill-level .out {
    width: 100%;
    height: 16px;
    margin-top: 6px;
    border-radius: 6px;
    background: #d7d7d7;
}
.skill-level .in0 {
    width: 82%;
    height: 16px;
    background: #00b38a;
    border-radius: 6px;
    animation: skillLevel0 2s;
}
.skill-level .in1 {
    width: 80%;
    height: 16px;
    background: #00b38a;
    border-radius: 6px;
    animation: skillLevel1 2s;
}
.skill-level .in2 {
    width: 70%;
    height: 16px;
    background: #00b38a;
    border-radius: 6px;
    animation: skillLevel2 2s;
}
.skill-level .in3 {
    width: 64%;
    height: 16px;
    background: #00b38a;
    border-radius: 6px;
    animation: skillLevel3 2s;
}
.skill-level .in4 {
    width: 60%;
    height: 16px;
    background: #00b38a;
    border-radius: 6px;
    animation: skillLevel4 2s;
}

.myUrl {
    margin-top: 142px;
    overflow: hidden;
}
.myUrl .iconfont {
    font-size: 24px;
}
.myUrl a {
    text-decoration: none;
    line-height: 32px;
    color: #555;
}
.myUrl a:hover {
    color: #000;
}

</style>



// WEBPACK FOOTER //
// src/components/ContentRight.vue